/**
 * Creates a new user to start from scratch.
 *
 * @return {PillarsUser}
 */
export const newUser = () => ({
  pillars: []
});